import "@accessible360/accessible-slick";

export const PXBanner = (function () {
    "use strict";

    let $sliders;

    function init() {
        $sliders = $(".pxblock--banner .slides");

        $sliders.each(function () {
            initBannerSlider($(this));
        });
    }

    function initBannerSlider($slider) {
        $slider.slick({
            arrowsPlacement: "afterSlides",
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
        });
    }

    return {
        init: init,
    };
})();
